import {
  BpResourcesProvider,
  BpResourcesService,
  HttpService,
} from "@sportal/api";

export const makeBpResourcesService = (
  http: HttpService,
  baseUrl: string
): BpResourcesService =>
  new BpResourcesService(new BpResourcesProvider(http, baseUrl));
